import { createSimpleReducer } from '../redux'

import { GetCustomTextsAction } from './actions'

export * from './actions'
export * from './selectors'
export * from './middlewares'

export const customTextsReducer = createSimpleReducer(GetCustomTextsAction)
